"use strict";
import { calculateGasMargin } from "utils/calculateGasMargin";
export async function buildGasLimitOverride(estimatedGas) {
  return { gasLimit: calculateGasMargin(await estimatedGas) };
}
